import React, { } from "react";
import { Col } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';
import SettingImageUtil from '../../quests/Settings/SettingImageUtil';
// import SettingImageAryDom from './SettingImageAryDom'

export default function SettingImage(props) {
    const questionIndex = props.index;
    const image = props.image || "";
    const images = props.images || [];
    const dispatch = useDispatch();
    // console.log(props);

    // function onChange(e) {
    //     try {
    //         const tmp = e.target.value;
    //         // console.log(tmp)
    //         dispatch({
    //             type: "QUESTION_SET_MA",
    //             key: "image",
    //             index: questionIndex,
    //             data: tmp
    //         });
    //     } catch (e) {

    //     }
    // }

    function onChange(qIndex, url) {
        try {
            // const tmp = e.target.value;
            console.log(url)
            dispatch({
                type: "QUESTION_SET_MA",
                key: "image",
                index: questionIndex,
                data: url
            });
        } catch (e) {

        }
    }

    function onChangeAry(qIndex, urlAry) {
        try {
            // const tmp = e.target.value;
            console.log(urlAry)
            dispatch({
                type: "QUESTION_SET_MA",
                key: "images",
                index: questionIndex,
                data: urlAry
            });
        } catch (e) {

        }
    }

    function render() {
        return (
            <Col>
                {/* <label>圖片</label> */}
                <SettingImageUtil
                    onChange={onChange}
                    isDisabled={false}
                    id={props.pid}
                    type={0} //0 : 專案, 1 : 廣告, 2 : 商品
                    // dataKey={questionIndex}
                    value={image}
                />
                {/* <label className="mt-2">圖片組</label>
                <SettingImageAryDom
                    // data={{ name: "圖片組" }}
                    onChange={onChangeAry}
                    isDisabled={false}
                    id={props.pid}
                    type={0} //0 : 專案, 1 : 廣告, 2 : 商品
                    // dataKey={questionIndex}
                    value={images}
                /> */}
            </Col>
        );
        // return (
        //     <>
        //         <Form.Group>
        //             <Form>
        //                 <Form.Row>
        //                     <Form.Label column xs="3">主圖連結:</Form.Label>
        //                     <Col className="text-left">
        //                         <Form.Control onChange={onChange} type="text" name={questionIndex + "rand-sub"} value={data} />
        //                     </Col>
        //                 </Form.Row>
        //             </Form>
        //         </Form.Group>
        //         <Col>
        //             <img src={data} style={{ "maxHeight": "200px", "maxWidth": "350px" }} />
        //         </Col>
        //     </>
        // );
    }

    return render();
}
